<div [ngStyle]="customStyles" class="checkbox">
  <div class="checkbox__container">
    <mat-checkbox
      id="{{controlid}}"
      name="{{controlid}}" 
      ngDefaultControl
      color="primary"
      [disabled]="disabled"
      [(ngModel)]="model"
      (change)="save(model)">
      <span [ngStyle]="labelCustomStyles">{{ label }}</span>
      <span class="required" *ngIf="isRequired"> *</span>
      <i *ngIf="subLabel">{{ subLabel }}</i>
    </mat-checkbox>
    <div class="checkbox-subcontent" *ngIf="model" [ngStyle]="subcontentCustomStyles">
      <ng-content></ng-content>
    </div>
  </div>
</div>
